import { BrandfolderHexColors } from '../enums/colors.js';

const defaultCheckboxLight = {
    backgroundColor: BrandfolderHexColors.White,
    backgroundColorChecked: BrandfolderHexColors.PurplePopsicle,
    backgroundColorDisabled: BrandfolderHexColors.Gray,
    backgroundColorIndeterminate: BrandfolderHexColors.PurplePopsicle,
    borderColor: BrandfolderHexColors.GrayBorder,
    borderColorChecked: BrandfolderHexColors.PurplePopsicle,
    borderColorDisabled: BrandfolderHexColors.GrayBorder,
    borderColorFocus: BrandfolderHexColors.Text,
    borderColorHover: BrandfolderHexColors.GrayMediumDark,
    borderColorIndeterminate: BrandfolderHexColors.PurplePopsicle,
    fillColorChecked: BrandfolderHexColors.White,
    fillColorDisabled: BrandfolderHexColors.White,
    fillColorIndeterminate: BrandfolderHexColors.White,
    outlineColorFocus: '#1895F5'
};

export { defaultCheckboxLight };
//# sourceMappingURL=checkbox.js.map
